var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDecor = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 10,
  height: 8,
  viewBox: "0 0 10 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.74758 1.66494L4.41409 7.66494C4.22415 7.87832 3.95217 8.00039 3.66653 8.00039C3.38088 8.00039 3.10891 7.87832 2.91897 7.66494L0.252466 4.66494C-0.114233 4.25185 -0.0771233 3.62002 0.335474 3.25283C0.749537 2.88613 1.3804 2.92324 1.74758 3.33584L3.66653 5.49502L8.25247 0.335838C8.62014 -0.0772476 9.251 -0.114357 9.66458 0.252831C10.0772 0.620018 10.1143 1.25185 9.74758 1.66494Z",
  fill: "white"
})));
export { SvgDecor as ReactComponent };
export default __webpack_public_path__ + "assets/icons/decor.476967.svg";